import React, { useState } from 'react';
import Typography from '@mui/material/Typography';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';;
import Button from '@mui/material/Button';;
import { FieldsetBox, LegendStyled } from '../styling/StyledComponents';

const wxChoices = [
  {name: 'RA',   group: 'prcp', long: 'Rain'},
  {name: 'DZ',   group: 'prcp', long: 'Drizzle'},
  {name: 'SN',   group: 'prcp', long: 'Snow'},
  {name: 'SG',   group: 'prcp', long: 'Snow grains'},
  {name: 'GR',   group: 'prcp', long: 'Hail'},
  {name: 'GS',   group: 'prcp', long: 'Small hail'},
  {name: 'PL',   group: 'prcp', long: 'Ice pellets'},
  {name: 'IC',   group: 'prcp', long: 'Ice crystals'},
  {name: 'TS',   group: 'prcp', long: 'Thunderstorm'},
  {name: 'UP',   group: 'prcp', long: 'Unknown'},
  {name: 'FG',   group: 'obst', long: 'Fog'},
  {name: 'BR',   group: 'obst', long: 'Mist'},
  {name: 'HZ',   group: 'obst', long: 'Haze'},
  {name: 'FU',   group: 'obst', long: 'Smoke'},
  {name: 'DU',   group: 'obst', long: 'Widespread dust'},
  {name: 'SA',   group: 'obst', long: 'Sand'},
  {name: 'PY',   group: 'obst', long: 'Spray'},
  {name: 'VA',   group: 'obst', long: 'Volcanic ash'},
  {name: 'FC',   group: 'misc', long: 'Funnel cloud'},
  {name: 'SQ',   group: 'misc', long: 'Squall'},
  {name: 'PO',   group: 'misc', long: 'Dust/sand whirls'},
  {name: 'DS',   group: 'misc', long: 'Duststorm'},
  {name: 'SS',   group: 'misc', long: 'Sandstorm'},
]

export default function WxVariableSelect(props) {
  const { userParams, setUserParams } = props;
  const [ clickStatus, setClickStatus ] = useState({'prcp': false, 'obst': false, 'misc': false})

  // local input storage structure
  const initialVarsMap = new Map(wxChoices.map(item => [item.name, userParams.wxvariables.indexOf(item.name) >= 0]));
  const [ varsMap, setVarsMap ] = useState(initialVarsMap);
  
  // information for groups of wx types
  const groups = {
    prcp: { choices: wxChoices.filter(v => v.group === 'prcp'), numberOfRows: 2, heading: "Precipitation" }, // was 6 rows, changed to 1 and let it wrap itself
    obst: { choices: wxChoices.filter(v => v.group === 'obst'), numberOfRows: 2, heading: "Obstructions"},   // was 4 rows
    misc: { choices: wxChoices.filter(v => v.group === 'misc'), numberOfRows: 1, heading: "Miscelleneous" }, // was 2 rows
  }

  // update data map when a box is checked
  const handleCheckboxChange = (event) => {
    const name = event.target.name;
	  const checked = event.target.checked;
    // update local map
    const newMap = new Map(varsMap);
    newMap.set(name, checked);
    setVarsMap(newMap);
    // update userParams
    const newVariables = wxChoices.filter(v => newMap.get(v.name)).map(v => v.name)
    setUserParams({ ...userParams, wxvariables: newVariables })
  }

  const handleSelectAll = (group) => {
    // update local map
    const newMap = new Map(varsMap);
    groups[group].choices.forEach((ch) => {
       newMap.set(ch.name, !clickStatus[group]);
    })
    setVarsMap(newMap);  
    // update userParams
    const newVariables = wxChoices.filter(v => newMap.get(v.name)).map(v => v.name)
    setUserParams({ ...userParams, wxvariables: newVariables })
    setClickStatus({...clickStatus, [group]:!clickStatus[group]})
  }

  // display a group of checkboxes
  const checkboxGroup = (group) => {
    const boxes = [];
    const n = groups[group].numberOfRows;
    const itemsPerRow = Math.ceil(groups[group].choices.length / n);
    for (let i = 0; i < n; i ++) {
        boxes.push (
            <FormGroup row key={i}>
                { groups[group].choices.slice(itemsPerRow*i, itemsPerRow*(i+1)).map((opt) => (
                    <FormControlLabel
                        key={opt.name}
                        control={
                            <Checkbox 
                                checked={varsMap.get(opt.name)} 
                                name={opt.name} 
                                sx={{ py: 0, pl: 1, pr: "3px" }} 
                                onChange={handleCheckboxChange}
                            />
                        }
                        label={<><Typography display="inline" sx={{verticalAlign: "middle"}}>{opt.name}</Typography><Typography display="inline" sx={{ fontSize: "0.8rem", fontStyle: "italic", verticalAlign: "middle" }}>-{opt.long}</Typography></>}
                    />  
                ))}
            </FormGroup>
        )
    }
    return boxes
  }

  const selectAllButton = (group) => {
    return (
        <Button 
            variant="outlined" 
            size="small"
            sx={{ m: 1, py: 0 }}
            onClick={() => handleSelectAll(group)}
        >
            {clickStatus[group] ? "Deselect" : "Select"} all
        </Button>
    )
  }

  return (
    <>
        <FieldsetBox component="fieldset" sx={{ mt: 1 }}>
            <LegendStyled>Include any of the selected weather types</LegendStyled>
            {Object.keys(groups).map(gk => (
              <div key={gk}>
                <Typography variant='subtitle1'>
                  {groups[gk].heading}:
                  {selectAllButton(gk)}
                </Typography>
                {checkboxGroup(gk)}
              </div>
            ))}
        </FieldsetBox>
    </>
  )
}
